import { render, staticRenderFns } from "./MedicalOrderTemplatesSelector.vue?vue&type=template&id=8ccb8b2a"
import script from "./MedicalOrderTemplatesSelector.vue?vue&type=script&lang=js"
export * from "./MedicalOrderTemplatesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports